




























































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import CustomTable from "@/components/form/CustomTable.vue";
import registrations from "@/getinfo-api/courseRegistrations";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import {
  Course as ICourse,
  Registration as IRegistration
} from "@/api-v2/course/models";
import CourseRegistrationsTableItem from "@/components/courses/CourseRegistrationsTableItem.vue";
import { RegistrationSort, SortFields } from "@/plugins/sort-fields";

@Component({ components: { CourseRegistrationsTableItem, CustomTable } })
export default class CourseRegistrationsTable extends Vue {
  @Prop() course!: ICourse;
  @Prop() registrationIds!: string[];
  @Prop() registrationForm!: any;
  checkedAll: boolean = false;
  checkedItems: IRegistration[] = [];
  indeterminate: boolean = false;
  pageNumber: number = 1;
  registrations: Array<IRegistration> = [];
  count: number = 0;
  isLoading: boolean = false;
  sorted: SortFields<RegistrationSort> = new SortFields(
    RegistrationSort.startedAt
  );
  form: any = {
    sort: this.sorted.sort,
    order: this.sorted.order,
    offset: 0,
    limit: 30
  };
  data() {
    return {
      registrations: undefined
    };
  }

  get sortStatus() {
    return RegistrationSort;
  }

  @Watch("registrationIds")
  checkRegistrations() {
    this.checkedItems = [];
    this.getRegistration();
  }

  acceptSort(sort: RegistrationSort) {
    this.sorted.changeSort(sort);
    this.pageNumber = 1;
    this.form.offset = 0;
    this.form.sort = this.sorted.sort;
    this.form.order = this.sorted.order;
    this.getRegistration();
  }

  changePage() {
    this.$nextTick(() => {
      this.checkedItems = [];
      if (this.form && this.form.limit) {
        this.form.offset = this.form.limit * (this.pageNumber - 1);
        this.getRegistration();
      }
    });
  }

  toggleAll(checked: boolean) {
    this.checkedItems = checked ? this.registrations.slice() : [];
  }

  editRegistration(el: IRegistration) {
    let index = this.registrations?.findIndex(item => el.id === item.id);
    Object.assign(this.registrations[index], el);
  }

  @Watch("checkedItems")
  checkSelected(newValue: any) {
    if (newValue.length === 0) {
      this.indeterminate = false;
      this.checkedAll = false;
    } else if (newValue.length === this.registrations.length) {
      this.indeterminate = false;
      this.checkedAll = true;
    } else {
      this.indeterminate = true;
      this.checkedAll = false;
    }
    this.$emit("input", this.checkedItems);
  }

  getCheckedRegistration(registration: IRegistration) {
    if (!this.checkedItems.some(el => el.id === registration.id)) {
      this.checkedItems.push(registration);
    } else {
      this.checkedItems = this.checkedItems.filter(
        el => el.id !== registration.id
      );
    }
  }

  checkState(id: string) {
    return this.checkedItems.some(el => el.id === id);
  }

  getRegistration() {
    this.form.courseIds = [this.course ? this.course.id : ""];
    this.form.ids = [this.registrationIds ? this.registrationIds : ""];
    this.isLoading = true;
    registrations(this.form)
      .then(res => {
        this.registrations = res.data.items;
        this.count = res.data.count;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  @Watch("course", { deep: true, immediate: true })
  checkCourse() {
    this.getRegistration();
  }

  @Watch("registrationForm", { deep: true, immediate: true })
  checkRegistrationForm() {
    if (this.registrationForm) {
      this.pageNumber = 1;
      this.form.offset = 0;
      this.form.statuses = [this.registrationForm.status];
      this.getRegistration();
    }
  }

  created() {}
}
